<template>

    <div class="container">

        <app-head title="Discounts" />

        <back />
        
        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Discounts') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.discounts.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="supplier" v-model="form.supplier_id">
                    <option :value="null">{{ __('Alle') }}</option>
                    <option :value="supplier.id" v-for="supplier in suppliers">{{ supplier.short_name || supplier.name }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="discounts.meta" />
        </div>

        <div class="card">
            <data-table :items="discounts.data"
                        :links="discounts.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="discount in discounts.data" :key="discount.id">
                    <td>
                        {{ discount.id }}
                    </td>
                    <td>
                        <template v-if="discount.supplier">
                            {{ discount.supplier.name }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        {{ discount.discount_type }}
                    </td>
                    <td>
                        <inertia-link class=" stretched-link" :href="route('admin.discounts.edit', discount)">
                            {{ discount.name }}
                        </inertia-link>
                    </td>
                    <td>
                        <boolean :value="discount.enabled" />
                    </td>
                    <td>
                        {{ discount.created_at | localizeDateTime }}
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';

    import Results from '@/shared/Admin/Results';

    import Boolean from '@/shared/Admin/Boolean';

    export default {
        props: [
            'filters',
            'suppliers',
            'discounts',
        ],
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
            Boolean,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    supplier_id: this.filters.supplier_id,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    supplier: {label: 'Supplier', sortable: 'supplier.name'},
                    discount_type: {label: 'Typ', sortable: 'discount_type'},
                    name: {label: 'Name', sortable: 'name'},
                    enabled: {label: 'Enabled', sortable: 'enabled'},
                    created_at: {label: 'Created', sortable: 'created_at'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.discounts.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>